import { useMemo } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { useMergePrismicPreviewData } from 'gatsby-plugin-prismic-previews'
import { useLocation } from '@reach/router'

import getLocalizedData from 'lib/getLocalizedData'

const votesQuery = graphql`
  query votesQuery {
    allPrismicFact {
      totalCount
      nodes {
        _previewable
        lang
      }
    }

    allPrismicVideosPage {
      edges {
        node {
          _previewable
          lang
          data {
            videos {
              youtube_embed_id
            }
          }
        }
      }
    }
  }
`

const useMaximumVotes = () => {
  const staticData = useStaticQuery(votesQuery)
  const { data } = useMergePrismicPreviewData(staticData)
  const { pathname } = useLocation()

  const prismicVideosPage = getLocalizedData(pathname, data.allPrismicVideosPage)
  const currentLang = prismicVideosPage?.lang

  const maximumVotes = useMemo(() => {
    const facts = data?.allPrismicFact?.nodes?.filter(({ lang }: { lang: string }) => lang === currentLang)?.length
    const videos = prismicVideosPage?.data?.videos?.length

    return (facts || 0) + (videos || 0)
  }, [currentLang, data?.allPrismicFact?.nodes, prismicVideosPage?.data?.videos?.length])

  return maximumVotes
}

export default useMaximumVotes
